// ----------------------------------------------------------------------------
//   Imports
// ----------------------------------------------------------------------------

// React
import React, {useState, useEffect, useContext} from "react";
import { useNavigate } from "react-router-dom";

// Material UI
import {
    Box,
} from "@mui/material";

// Custom Components
import Error from "./Error";
import LoadingIcon from "./loading/LoadingIcon";

// Custom Contexts
import { UserContext } from "../Contexts";

// Custom Scripts
import { userRoles }       from "../api/user-service";
import { LoadedDataState } from "../scripts/loadedData/loadedData";


// ----------------------------------------------------------------------------
//   Main Component
// ----------------------------------------------------------------------------

const Dashboard = () => {

    // Context
    const { userData } = useContext( UserContext );
    const navigate = useNavigate();

    // Redirect to the correct dashboard on user data load
    useEffect(() => {

        // Only continue if user data loaded properly
        if ( userData.state !== LoadedDataState.SUCCESS ) return;

        // Redirect to the correct dashboard
        // TODO: Should admin users actually redirect to the "/admin" page?
        // if ( userData.value?.role === userRoles.ADMIN ) {
        //     navigate('/admin');
        // } else {
        //     navigate('/student');
        // }
        navigate('/student');

    }, [ userData ]);

    // If user data failed to load, show the error message
    if ( userData.state === LoadedDataState.FAILURE ) {
        return <Error message={ userData.error } />
    }

    // If user data is still loading, show the loading icon
    if ( userData.state === LoadedDataState.WORKING || userData.state === LoadedDataState.NONE ) {
        return <LoadingIcon />
    }
}


// ----------------------------------------------------------------------------
//   Export(s)
// ----------------------------------------------------------------------------

export default Dashboard;
